import { API_BASE_URL } from '../config';

/** Absolute media URL for <img src>. Passes through https Cloudinary URLs; prefixes API origin for relative paths. */
export function ensureMediaUrl(url) {
    if (!url || typeof url !== 'string') return url;
    if (
        url.startsWith('http://') ||
        url.startsWith('https://') ||
        url.startsWith('data:') ||
        url.startsWith('blob:')
    ) {
        return url;
    }
    const base = API_BASE_URL.replace(/\/$/, '');
    return `${base}/${url.replace(/^\//, '')}`;
}

/** Review/customer photo URLs that can actually render (skip removed local /uploads paths). */
export function isDisplayableMediaUrl(url) {
    if (!url || typeof url !== 'string' || !url.trim()) return false;
    if (url.startsWith('/uploads/') || url.includes('/uploads/reviews/')) return false;
    const abs = ensureMediaUrl(url);
    return Boolean(
        abs &&
        (abs.startsWith('http://') ||
            abs.startsWith('https://') ||
            abs.startsWith('data:') ||
            abs.startsWith('blob:'))
    );
}

/** Map + filter review image list for <img src>. */
export function reviewImageUrls(images) {
    if (!Array.isArray(images)) return [];
    return images.filter(isDisplayableMediaUrl).map(ensureMediaUrl);
}
